import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";
import { setRouter } from "./lib/router";
import "@omnabase/ui/ui.css";
import "./empty.css";
import { App } from "./App";
import { applyRememberedLook } from "./lib/look";
import { installTips } from "@omnabase/ui";
import { followPopUpClicks } from "./lib/push";

applyRememberedLook(); // before the first paint
installTips(); // the kit's tooltips stay inside the card that would clip them

// a data router: `navigate(to, { viewTransition: true })` (the phone's slides, lib/nav.ts) only runs with one; the app's <Routes> are its descendants
const router = createBrowserRouter([{ path: "*", element: <App /> }]);
setRouter(router);
followPopUpClicks(); // browser notifications (2026-10-18): a pop-up's click takes an open tab to its item
createRoot(document.getElementById("root")!).render(<StrictMode><RouterProvider router={router} /></StrictMode>);
